export default __webpack_public_path__ + "static/media/Spritesheet2.c77c1192.png";